import { render, staticRenderFns } from "./Obligations.vue?vue&type=template&id=2ab96e55"
import script from "./Obligations.vue?vue&type=script&lang=js"
export * from "./Obligations.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports